import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import icon from './assets/carrets-left.svg'
import bg1 from './assets/news-bg-1.png'
import bg2 from './assets/news-bg-2.png'
import bg3 from './assets/news-bg-3.png'
import { SectionHeading } from './SectionHeading'

type Story = {
    title: string
    preview: string
    url: string
    source: string
    /** ISO date, rendered as UTC. Every one of these is recoverable from its own URL. */
    date: string
}

const news: Story[] = [
    {
        title: 'Viral extraction shooter says it will pay you real money just for playing',
        preview:
            'Dexerto covers BR1: INFINITE and how its economy actually works: a spawn fee buys you into a live server, every elimination pays out in real money, and time spent in the arena earns on top of it. The piece reports players have taken more than $100,000 out of the game since launch.',
        url: 'https://www.dexerto.com/gaming/viral-extraction-shooter-says-it-will-pay-you-real-money-just-for-playing-3395532/',
        source: 'Dexerto',
        date: '2026-08-06',
    },
    {
        title: 'BRAVO READY Announces Strategic Investment From Magic Eden',
        preview:
            "BRAVO READY, creator of BR1: INFINITE, the world's first pay to spawn, kill to earn shooting game, today announced a new strategic investment from Magic Eden, adding to its expanding list of investors, which includes Krafton (owners of PUBG), 6th Man Ventures, and Solana Ventures. The funding provided by this investment will be directed towards the further development and mass adoption of BR1: INFINITE.",
        url: 'https://www.businesswire.com/news/home/20230330005710/en/BRAVO-READY-Announces-Strategic-Investment-From-Magic-Eden',
        source: 'Business Wire',
        date: '2023-03-30',
    },
    {
        title: 'BRAVO READY Announces Strategic Investment From Aptos',
        preview:
            "BRAVO READY, creator of BR1: INFINITE, the world's first pay-to-spawn, kill-to-earn shooting game, today announced a new strategic investment from Aptos Labs, which will be used to launch ‘Aptos Arena’, an exclusive game collaboration between the two studios, and future Aptos integrations with BR1: INFINITE.",
        url: 'https://www.businesswire.com/news/home/20230316005725/en/BRAVO-READY-Announces-Strategic-Investment-From-Aptos',
        source: 'Business Wire',
        date: '2023-03-16',
    },
    {
        title: 'BRAVO READY Announces Strategic Investment from Sino Global Capital',
        preview:
            'BRAVO READY, creator of BR1: Infinite Royale, the first risk-based shooter, today announced that Sino Global Capital has made an investment in the company as part of its $3.5MM seed round. BR1: Infinite Royale is an innovative game that has developed a loyal following thanks to a unique monetary model that allows gamers to pay to spawn and earn money for every player killed. To play the game, visit https://www.br1game.com/. Sino Global Capital is the GP for Liquid Value Fund I, a $200M early-stage VC fund.',
        url: 'https://www.businesswire.com/news/home/20220913005914/en/BRAVO-READY-Announces-Strategic-Investment-from-Sino-Global-Capital',
        source: 'Business Wire',
        date: '2022-09-13',
    },
    {
        title: 'Shima Capital Becomes Newest Member of BRAVO READY Funding Consortium',
        preview:
            'BRAVO READY, creator of BR1: Infinite Royale, the first risk-based shooter, welcomes Shima Capital to its growing list of investors as part of its initial $3.5MM seed round. BR1: Infinite Royale has developed a loyal following thanks to a unique monetary model that allows gamers to pay $1 to spawn and earn SOL for every player killed. To play the game, visit https://www.br1game.com/.',
        url: 'https://www.businesswire.com/news/home/20220830006018/en/Shima-Capital-Becomes-Newest-Member-of-BRAVO-READY-Funding-Consortium',
        source: 'Business Wire',
        date: '2022-08-30',
    },
    {
        title: 'Fractal Cofounder Justin Kan Joins Investor Group Backing BRAVO READY',
        preview:
            'BRAVO READY, creator of BR1: Infinite Royale, a first-of-its-kind gaming experience that marries NFT technology and win-to-earn smart contract automation, today announced that Fractal cofounder and Twitch pioneer Justin Kan is part of the company’s initial $3.5 million fund raise to accelerate game development and build its development studio. BR1: Infinite Royale is an innovative risk-based shooter, and has developed a loyal following thanks to a unique monetary model that allows gamers to pay $1 to spawn and earn SOL for every player killed. To play the game, visit https://www.br1game.com/.',
        url: 'https://www.businesswire.com/news/home/20220808005863/en/Fractal-Cofounder-Justin-Kan-Joins-Investor-Group-Backing-BRAVO-READY',
        source: 'Business Wire',
        date: '2022-08-08',
    },
    {
        title: 'Gaming Pioneer BRAVO READY Announces Funding Agreement and Development Partnership with 6th Man Ventures on Revolutionary Competitive Shooter BR1: Infinite Royale',
        preview:
            'BRAVO READY, creator of BR1: Infinite Royale, a first-of-its-kind gaming experience that marries NFT technology and win-to-earn smart contract automation, today announced a funding and general support agreement with leading venture capital firm, 6th Man Ventures. The funding will be used to accelerate game and software development.',
        url: 'https://www.businesswire.com/news/home/20220727005229/en/Gaming-Pioneer-BRAVO-READY-Announces-Funding-Agreement-and-Development-Partnership-with-6th-Man-Ventures-on-Revolutionary-Competitive-Shooter-BR1-Infinite-Royale',
        source: 'Business Wire',
        date: '2022-07-27',
    },
    {
        title: 'Gaming Pioneer BRAVO READY Announces Strategic Investment by Big Brain Holdings',
        preview:
            'BRAVO READY, creator of BR1: Infinite Royale, a first-of-its-kind gaming experience that marries NFT technology and win-to-earn smart contract automation, today announced that crypto investment fund Big Brain Holdings has joined its blue chip team of funders as the company accelerates growth for its risk-based shooter game and other projects. Big Brain is a crypto-exclusive fund investing in pre-seed, seed, and early-stage projects.',
        url: 'https://www.businesswire.com/news/home/20220726006121/en/Gaming-Pioneer-BRAVO-READY-Announces-Strategic-Investment-by-Big-Brain-Holdings',
        source: 'Business Wire',
        date: '2022-07-26',
    },
    {
        title: 'Gaming Pioneer BRAVO READY Announces $3M Seed Round and Development Partnerships with Solana Ventures, 6th Man Ventures, Justin Kan, Sino Global Capital, and Shima Capital',
        preview:
            'BRAVO READY, creator of BR1: Infinite Royale, a first-of-its-kind gaming experience that marries NFT technology and win-to-earn smart contract automation, today announced the completion of an initial $3 million seed round led by top technology companies and investors in the gaming and web3 sectors, including Solana Ventures, 6th Man Ventures, Sino Global Capital, and Shima Capital. The funding will be used to accelerate game and software development.',
        url: 'https://www.businesswire.com/news/home/20220711005877/en/Gaming-Pioneer-BRAVO-READY-Announces-3M-Seed-Round-and-Development-Partnerships-with-Solana-Ventures-6th-Man-Ventures-Justin-Kan-Sino-Global-Capital-and-Shima-Capital',
        source: 'Business Wire',
        date: '2022-07-11',
    },
]

const backgrounds = [bg1, bg2, bg3]

/**
 * `timeZone: 'UTC'` is not optional. `new Date('2026-08-06')` is parsed as UTC midnight, so
 * formatting it in any western timezone renders the 5th.
 */
const formatDate = (iso: string) =>
    new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })

/** Source and date, in the one place both are shown. */
const Byline = ({ story, className = '' }: { story: Story; className?: string }) => (
    <div className={`flex flex-row flex-wrap items-center gap-x-2 text-[0.625rem] tracking-[0.2em] ${className}`}>
        <span className='font-black'>{story.source.toUpperCase()}</span>
        <span aria-hidden>·</span>
        <time dateTime={story.date}>{formatDate(story.date).toUpperCase()}</time>
    </div>
)

/*
  There was a `LeadStory` here — the newest item rendered as a full-bleed card, twice the height of
  the rest, with an accent chip. It made the section look like two different components stacked, and
  the Dexerto piece is not a different *kind* of story, only a more recent one. Every item now uses
  the one card below, in date order, so recency is carried by position and the date on the byline
  rather than by a second layout.
*/

/**
 * Everything after the lead.
 *
 * The whole card is one anchor. It used to be two boxes side by side of which only the right one —
 * the summary — was a link, so clicking the headline, which is the part that tells you what the
 * story is, did nothing at all.
 *
 * `md:grid-cols-[1fr_2fr]` inside the anchor keeps the desktop composition the section already had;
 * below `md` the two halves stack, because a 95px title column wrapped the headlines one word to a
 * line.
 */
const StoryCard = ({ story, background }: { story: Story; background: string }) => (
    <a
        href={story.url}
        target='_blank'
        rel='noreferrer'
        className='group grid grid-cols-1 border border-transparent transition-colors hover:border-white/25 md:grid-cols-[1fr_2fr]'
    >
        <div className='flex flex-col gap-2 bg-[#393939] p-[1em] transition-colors group-hover:bg-[#454545]'>
            <Byline story={story} className='text-white/50' />
            {/* Floors on both of these. They were `max(var(--text-2xs), …cqi)`, and on a phone the
                container term rounds to nothing — so a headline rendered at the 10px floor, which
                is fine print, not a headline. */}
            <h3 className='line-clamp-3 text-[clamp(0.8125rem,1.1vw,1.375rem)] font-bold md:line-clamp-4'>
                {story.title}
            </h3>
        </div>
        <div
            className='flex flex-col justify-between gap-y-[1em] bg-cover bg-center bg-no-repeat p-[1em] text-[clamp(0.75rem,0.85vw,1rem)]'
            style={{ backgroundImage: `url(${background})` }}
        >
            <div className='line-clamp-3 text-white/65 transition-colors group-hover:text-white'>{story.preview}</div>
            <div className='flex flex-row items-center justify-between'>
                <b>READ MORE</b>
                <img src={icon} width={72} height={15} className='h-[0.75em] w-auto' alt='' />
            </div>
        </div>
    </a>
)

export function News() {
    const [collapsed, setCollapsed] = useState(true)
    const items = collapsed ? news.slice(0, 4) : news

    return (
        <div id='news' className='flex flex-col py-8'>
            <SectionHeading className='mb-6'>BRAVO READY NEWS</SectionHeading>
            {/* A column of cards, not a grid of halves. The two-column composition now lives inside
                each card, where it belongs — as an outer grid it forced every card to be exactly
                two cells, which is why the whole row could not be a single link. */}
            <div className='mx-auto mb-6 flex w-[calc(100%-2rem)] flex-col gap-4 md:w-3/4'>
                {items.map((story, i) => (
                    <StoryCard key={story.url} story={story} background={backgrounds[i % backgrounds.length]} />
                ))}
                {/* Both directions. A one-way expander leaves someone who opened nine stories with
                    no way back but the scrollbar. */}
                <button
                    type='button'
                    className='flex min-h-[2.75rem] flex-row items-center justify-center gap-x-[1em] bg-[linear-gradient(90deg,rgba(70,70,70,0.50)_-30.24%,rgba(70,70,70,0.11)_134.85%)] p-[1em] text-xs font-bold tracking-[0.15em] transition-[filter] hover:brightness-150'
                    onClick={() => setCollapsed((prev) => !prev)}
                >
                    <FontAwesomeIcon icon={collapsed ? faCaretDown : faCaretUp} />
                    <span>{collapsed ? 'SHOW ALL' : 'SHOW LESS'}</span>
                    <FontAwesomeIcon icon={collapsed ? faCaretDown : faCaretUp} />
                </button>
            </div>
        </div>
    )
}
